// removed by extract-text-webpack-plugin
module.exports = {"label":"Ga2b72d Gfbbf38"};